import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { AirwaysExpenseService } from './../../service/airways-expense.service';
import { CommonService } from './../../service/common.service';
import { DatePipe } from '@angular/common';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { isNullOrEmpty, deepCopy, getForwarderByPermission, getDataScopeByPermission } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { finalize } from 'rxjs/operators';
import * as xlsx from 'xlsx';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { endOfDay, startOfDay } from 'date-fns';

@Component({
  selector: 'laas-airways-expense-setting',
  templateUrl: './airways-expense-setting.component.html',
  styleUrls: ['./airways-expense-setting.component.scss']
})
export class AirwaysExpenseSettingComponent extends SessionBaseComponent implements OnInit {
  readonly preferenceKey: string;
  readonly permissionCode = PermissionConstants.ViewAirwaysExpenseSetting;
  currentLang: string = this.laasSetting.language;
  @ViewChild('effectDate') effectDate!: CalendarComponent;

  forwarderOptions: any[];
  feeTypeOptions: any[];
  currencyOptions: any[];
  statusOptions: any[];
  countryOptions: any[];
  iataAreaOptions: any[];
  isActivatedOptions: any;
  columns: any[];
  isSearchFormOpen: boolean;
  searchParams: any;
  searchForm: FormGroup;
  airwaysExpenseRows: any[];
  selectedAirwaysExpenseRows: any[];
  isLoading: boolean;
  isShowImportAirwaysExpenseModal: boolean;
  isApplyBtnDisabled = true;
  isWithdrawBtnDisabled = true;
  isDeleteBtnDisabled = true;
  isApproveBtnDisabled = true;
  isCancelBtnDisabled = true;
  isCreateBtnDisabled = true;

  constructor(
    private commonService: CommonService,
    private commonDataService: CommonDataService,
    private dropdownOptionsService: DropdownOptionsService,
    private airwaysExpenseService: AirwaysExpenseService,
    injector: Injector,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.AirwaysExpenseSetting;
    this.isSearchFormOpen = true;
    this.isLoading = false;
    this.airwaysExpenseRows = [];
    this.selectedAirwaysExpenseRows = [];
    this.forwarderOptions = [];
    this.feeTypeOptions = [];
    this.currencyOptions = [];
    this.statusOptions = [];
    this.countryOptions = [];
    this.iataAreaOptions = [];
    this.isShowImportAirwaysExpenseModal = false;

    this.columns = [
      { field: 'seqNo', header: 'FSCSSCSetting.MainTable.SerialNum', sort: true },
      { field: 'forwarder', header: 'FSCSSCSetting.MainTable.Forwarder', sort: true },
      { field: 'status', header: 'FSCSSCSetting.MainTable.Status', sort: true },
      { field: 'feeType', header: 'FSCSSCSetting.MainTable.CostType', sort: true },
      { field: 'currency', header: 'FSCSSCSetting.MainTable.Currency', sort: true },
      { field: 'amount', header: 'FSCSSCSetting.MainTable.Amount', sort: true },
      { field: 'rfqCategory', header: 'FSCSSCSetting.MainTable.DocumentType', sort: true },
      { field: 'fromCountry', header: 'FSCSSCSetting.MainTable.DepartureCountry', sort: true },
      { field: 'toIataArea', header: 'FSCSSCSetting.MainTable.DestinationIATA', sort: true },
      { field: 'remark', header: 'FSCSSCSetting.MainTable.Remarks', sort: true },
      { field: 'isActivated', header: 'FSCSSCSetting.MainTable.Effective', sort: true },
      { field: 'startDt', header: 'FSCSSCSetting.MainTable.EffectiveStart', sort: true },
      { field: 'endDt', header: 'FSCSSCSetting.MainTable.EffectiveEnd', sort: true },
      { field: 'createUser', header: 'FSCSSCSetting.MainTable.Creator', sort: true },
      { field: 'createDt', header: 'FSCSSCSetting.MainTable.CreationTime', dataType: 'date', sort: true },
      { field: 'updateUser', header: 'FSCSSCSetting.MainTable.UpdateBy', sort: true },
      { field: 'updateDt', header: 'FSCSSCSetting.MainTable.UpdateTime', dataType: 'date', sort: true },
    ];
    this.searchParams =  {
      forwarder: [],
      feeType: [],
      startSeqNo: null,
      endSeqNo: null,
      fromCountry: [],
      toIataArea: [],
      status: [],
      isActivated: '1',
      startDt: null,
      endDt: null
    };
    this.searchForm = this.fb.group({
      forwarder: [],
      feeType: [],
      startSeqNo: null,
      endSeqNo: null,
      fromCountry: [],
      toIataArea: [],
      status: [],
      isActivated: '1',
      startDt: startOfDay(new Date()),
      endDt: endOfDay(new Date())
    });
    this.isActivatedOptions = [];
  }

  async ngOnInit(): Promise<void> {
    this.logger.info('AirwaysExpenseSettingComponent onInit.');
    await super.ngOnInit();

    this.isActivatedOptions = [
      { label: 'Y', value: '1' },
      { label: 'N', value: '0' }
    ];

    this.searchParams.facility = this.laasSetting.facility;

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.filter((x: any) => {
          return ( this.userProfile.userType === UserType.SuperAdmin.toString() ||
          this.userProfile.userType === UserType.Shipping.toString() ||
          getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'RFQStatus').subscribe({
      next: result => {
        this.statusOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.commonService.getFeeType('Airways').subscribe({
      next: result => {
        this.feeTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.feeTypeCode}-${x.feeTypeName}`,
            value: x.feeTypeCode,
          };
        });
      }
    });

    this.commonService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.currency_code}-${x.currency_name}`,
            value: x.currency_code,
          };
        });
      }
    });

    this.dropdownOptionsService.getVCountryOptions().subscribe({
      next: result => {
        this.countryOptions = [...result].map((x: any) => {
          return {
            label: x.countryName,
            value: x.countryCode,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'IATAArea').subscribe({
      next: result => {
        this.iataAreaOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    // 申請
    if (this.userProfile.userType === UserType.SuperAdmin.toString() ||
        this.permissionCodes.includes(PermissionConstants.BtnAirwaysExpenseApply)) {
      this.isApplyBtnDisabled = false;
    }

    // 撤回
    if (this.userProfile.userType === UserType.SuperAdmin.toString() ||
        this.permissionCodes.includes(PermissionConstants.BtnAirwaysExpenseRecall)) {
      this.isWithdrawBtnDisabled = false;
    }

    // 核准
    if (this.userProfile.userType === UserType.SuperAdmin.toString() ||
        this.permissionCodes.includes(PermissionConstants.BtnAirwaysExpenseDelete)) {
      this.isDeleteBtnDisabled = false;
    }

    // 刪除
    if (this.userProfile.userType === UserType.SuperAdmin.toString() ||
        this.permissionCodes.includes(PermissionConstants.BtnAirwaysExpenseApproved)) {
      this.isApproveBtnDisabled = false;
    }

    // 作廢
    if (this.userProfile.userType === UserType.SuperAdmin.toString() ||
        this.permissionCodes.includes(PermissionConstants.BtnAirwaysExpenseInvalid)) {
      this.isCancelBtnDisabled = false;
    }

    if (this.userProfile.userType === UserType.SuperAdmin.toString() ||
        this.permissionCodes.includes(PermissionConstants.CreateAirwaysExpense)) {
      this.isCreateBtnDisabled = false;
    }
  }

  searchClickBtn(event: any): void{
    if (this.searchParams.startSeqNo > this.searchParams.endSeqNo){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.CheckSerialNum'));
      return;
    }

    console.log('params: ' + JSON.stringify(this.searchParams));
    this.isLoading = true;

    const params = deepCopy(this.searchParams);
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);

    this.airwaysExpenseService.getAirwaysExpense(params)
      .pipe(finalize(() => {
        this.isLoading = false;
        this.isSearchFormOpen = false;
      }))
      .subscribe({
        next: result => {
          this.airwaysExpenseRows = result;
        }
      });
  }

  resetClickBtn(event: any): void {
    this.searchForm.reset();
    this.effectDate.ngOnInit();
    this.searchForm.controls.startDt.setValue(startOfDay(new Date()));
    this.searchForm.controls.endDt.setValue(endOfDay(new Date()));
  }

  addClickBtn(event: any): void{
    this.routeStateService.navigateTo('/Setting/AirwaysExpenseSettingAdd', true);
  }

  importClickBtn(event: any): void{
    this.isShowImportAirwaysExpenseModal = true;
  }

  exportClickBtn(event: any): void{
    const dataRows = [];
    for (const item of this.airwaysExpenseRows) {
      const row = {} as any;
      const columns = [...this.columns];
      columns.splice(1, 0, { field: 'facility', header: '倉別', sort: true });
      for (const column of columns) {
        if (item.hasOwnProperty(column.field)) {
          let value = item[column.field];
          switch (column.field){
            case 'forwarder':
              value = this.forwarderOptions.find(x => x.value === value)?.label;
              break;
            case 'feeType':
              value = this.feeTypeOptions.find(x => x.value === value)?.label;
              break;
            case 'currency':
              value = this.currencyOptions.find(x => x.value === value)?.label;
              break;
            case 'status':
              value = this.statusOptions.find(x => x.value === value)?.label;
              break;
            case 'fromCountry':
              value = this.countryOptions.find(x => x.value === value)?.label;
              break;
            case 'toIataArea':
              value = this.iataAreaOptions.find(x => x.value === value)?.label;
              break;
            case 'isActivated':
              value = this.isActivatedOptions.find((x: any) => x.value === value)?.label;
              break;
            case 'startDt':
              value = this.datePipe.transform(value, 'yyyy-MM-dd', this.laasSetting.facilityTimeZone);
              break;
            case 'endDt':
              value = this.datePipe.transform(value, 'yyyy-MM-dd', this.laasSetting.facilityTimeZone);
              break;
            default:
              switch (column.dataType) {
                case 'date':
                  value = this.datePipe.transform(value, 'yyyy-MM-dd HH:mm:ss', this.laasSetting.facilityTimeZone);
                  break;
                default:
                  break;
              }
              break;
          }
          row[column.header] = value;
        }
      }
      dataRows.push(row);
    }

    const worksheet = xlsx.utils.json_to_sheet(dataRows);
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob(
      [excelBuffer],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );
    const url = URL.createObjectURL(data);
    const linkEle = document.createElement('a');
    linkEle.href = url;
    linkEle.download = 'Airways Expense Result';
    linkEle.click();
    URL.revokeObjectURL(url);
    linkEle.remove();
  }

  applyClickBtn(event: any): void{
    this.translateService.get('AirwaysExpenseSetting.Confirm.ConfirmApply').subscribe({
      next: confirmApply => {
        this.confirmationService.confirm({
          target: event.target,
          message: confirmApply,
          icon: 'pi pi-info-circle',
          accept: () => {
            this.applyAirwaysExpense(event);
          },
          reject: () => {
            // reject action
          }
        });
      }
    });
  }

  applyAirwaysExpense(event: any): void{
    if (this.selectedAirwaysExpenseRows.some(x => x.status !== this.selectedAirwaysExpenseRows[0].status)){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.MaintenanceOfData'));
      return;
    }
    if (this.selectedAirwaysExpenseRows.every(x => x.status === '2')){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.ApplicationInProgress'));
      return;
    }
    if (this.selectedAirwaysExpenseRows.every(x => ['3', '6'].includes(x.status))){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.PendingData'));
      return;
    }
    if (this.selectedAirwaysExpenseRows.some(x => x.isActivated !== '1')){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.DataValid'));
      return;
    }

    var updatedAirwaysExpenseRows = deepCopy(this.selectedAirwaysExpenseRows);
    updatedAirwaysExpenseRows?.forEach(x => {
      x.status = '2';
      x.updateUser = this.userProfile.userName;
      this.airwaysExpenseService.updateAirwaysExpense(x).subscribe({
        next: result => {
          this.toastService.success(this.translateService.instant('AirwaysExpenseSetting.Success.UpdatedAppInProgress'));
          this.searchClickBtn(null);
        }
      });
    });
    this.selectedAirwaysExpenseRows = [];
  }

  withdrawClickBtn(event: any): void{
    this.translateService.get('AirwaysExpenseSetting.Confirm.ConfirmWithdraw').subscribe({
      next: confirmWithdraw => {
        this.confirmationService.confirm({
          target: event.target,
          message: confirmWithdraw,
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.withdrawAirwaysExpense(event);
          },
          reject: () => {
            // reject action
          }
        });
      }
    });
  }

  withdrawAirwaysExpense(event: any): void{
    if (this.selectedAirwaysExpenseRows.some(x => x.status !== this.selectedAirwaysExpenseRows[0].status)){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.MaintenanceOfData'));
      return;
    }
    if (this.selectedAirwaysExpenseRows.every(x => ['1', '3', '6'].includes(x.status))){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.OnlyApplicationWithdrawn'));
      return;
    }
    if (this.selectedAirwaysExpenseRows.some(x => x.isActivated !== '1')){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.DataValid'));
      return;
    }

    var updatedAirwaysExpenseRows = deepCopy(this.selectedAirwaysExpenseRows);
    updatedAirwaysExpenseRows?.forEach(x => {
      x.status = '1';
      x.updateUser = this.userProfile.userName;
      this.airwaysExpenseService.updateAirwaysExpense(x).subscribe({
        next: result => {
          this.toastService.success(this.translateService.instant('AirwaysExpenseSetting.Success.UpdatedPending'));
          this.searchClickBtn(null);
        }
      });
    });
    this.selectedAirwaysExpenseRows = [];
  }

  deleteClickBtn(event: any): void{
    var seqNo = this.selectedAirwaysExpenseRows.map(x => x.seqNo);
    this.confirmationService.confirm({
      target: event.target,
      message: this.translateService.instant('AirwaysExpenseSetting.Confirm.ConfirmDelete'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
          //confirm action
          seqNo.forEach(x => {
            this.airwaysExpenseService.deleteAirwaysExpense(x).subscribe({
              next: result => {
                this.toastService.info(this.translateService.instant('AirwaysExpenseSetting.Info.DeleteSuccess'));
              },
              complete: () => {
                this.searchClickBtn(null);
                this.selectedAirwaysExpenseRows = [];
              }
            });
          });
      },
      reject: () => {
          //reject action
      }
    });
  }

  approveClickBtn(event: any): void{
    this.translateService.get('AirwaysExpenseSetting.Confirm.ConfirmApprove').subscribe({
      next: confirmApprove => {
        this.confirmationService.confirm({
          target: event.target,
          message: confirmApprove,
          icon: 'pi pi-info-circle',
          accept: () => {
            this.approveAirwaysExpense(event);
          },
          reject: () => {
            // reject action
          }
        });
      }
    });
  }

  approveAirwaysExpense(event: any): void{
    if (this.selectedAirwaysExpenseRows.some(x => x.status !== this.selectedAirwaysExpenseRows[0].status)){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.MaintenanceOfData'));
      return;
    }
    if (this.selectedAirwaysExpenseRows.every(x => x.status === '6')){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.ApplicationApproved'));
      return;
    }
    if (this.selectedAirwaysExpenseRows.every(x => ['1', '3'].includes(x.status))){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.OnlyApplicationApproved'));
      return;
    }
    if (this.selectedAirwaysExpenseRows.some(x => x.isActivated !== '1')){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.DataValid'));
      return;
    }

    var updatedAirwaysExpenseRows = deepCopy(this.selectedAirwaysExpenseRows);
    updatedAirwaysExpenseRows?.forEach(x => {
      x.status = '6';
      x.updateUser = this.userProfile.userName;
      this.airwaysExpenseService.updateAirwaysExpense(x).subscribe({
        next: result => {
          this.toastService.success(this.translateService.instant('AirwaysExpenseSetting.Success.UpdatedApproved'));
          this.searchClickBtn(null);
        }
      });
    });
    this.selectedAirwaysExpenseRows = [];
  }

  cancelClickBtn(event: any): void{
    this.translateService.get('AirwaysExpenseSetting.Confirm.ConfirmCancel').subscribe({
      next: confirmCancel => {
        this.confirmationService.confirm({
          target: event.target,
          message: confirmCancel,
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.cancelAirwaysExpense(event);
          },
          reject: () => {
            // reject action
          }
        });
      }
    });
  }

  cancelAirwaysExpense(event: any): void{
    if (this.selectedAirwaysExpenseRows.some(x => x.isActivated !== '1')){
      this.toastService.warn(this.translateService.instant('AirwaysExpenseSetting.Alert.DataValid'));
      return;
    }

    var updatedAirwaysExpenseRows = deepCopy(this.selectedAirwaysExpenseRows);
    updatedAirwaysExpenseRows?.forEach(x => {
      x.isActivated = '0';
      x.updateUser = this.userProfile.userName;
      this.airwaysExpenseService.updateAirwaysExpense(x).subscribe({
        next: result => {
          this.translateService.get('Common.Message.SuccessSave')
              .subscribe({
                next: msg => {
                  this.toastService.success(msg);
                  this.searchClickBtn(null);
                }
              });
        }
      });
    });
    this.selectedAirwaysExpenseRows = [];
  }

  seqNoLinkClick(event: any, rowData: any): void{
    this.routeStateService.navigateTo('/Setting/AirwaysExpenseSettingDetail', rowData, true);
  }

  importAirwaysExpense(event: any): void{
    this.isShowImportAirwaysExpenseModal = false;
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case "effectDate":
        this.searchParams.startDt = date.startDate;
        this.searchParams.endDt = date.endDate;
        break;
    }
  }
}
